module.exports = __webpack_public_path__ + "media/images/carousel_right-8e72719cfbd72652d067212d66e881a2.svg";